export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      communityUuid: "community001",
      communityNumber: "1001",
      communityName: "○○地域サポート",
      tenantName: 'テナント名',
      modelNumber: [
        "xxxxxx"
      ],
      note: "xxxxxx",
      status: 1,
      communityTantous: [
        "相良　太郎"
      ],
      locations: [
        {
          locationNumber: "xxxxxx",
          locationUuid: "locations001",
          deviceSerial: "xxxxxx",
          modelNumber: "xxxxxx",
          modelName: "xxxxxx",
          profile1: {
            profileOrder: 1,
            body: "xxxxxx",
          },
          status: 1
        }
      ]
    }
  }
}